import React, { useState, useEffect } from 'react';
import ContractHeader from '../Contract/components/Navigation/ContractHeader';
import { getMyContracts } from '../Contract/services/contractApi';
import './styles.css';
import { useNavigate } from 'react-router-dom';
import { Spin } from 'antd';

const Welcome = () => {
    const navigate = useNavigate();
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getMyContracts()
            .then((data) => {
                const list = Array.isArray(data) ? data : [data];
                setContracts(list);
            })
            .catch(() => {
                setContracts([]);
            })
            .finally(() => setLoading(false));
    }, []);

    return (
        <div className="welcome-page">
            <ContractHeader />

            <main className="welcome-content">
                <h1 className="title">Welcome to Arett Sales Contract Website</h1>

                <section className="options">
                    <h2 className="options-title">Exhibitor Options</h2>

                    {loading ? (
                        <div style={{ padding: '12px 0' }}>
                            <Spin size="small" style={{ marginRight: 8 }} />
                            <span style={{ color: '#6b7280', fontSize: 14 }}>Loading...</span>
                        </div>
                    ) : contracts.length === 0 ? (
                        <p style={{ color: '#6b7280', fontSize: 14, margin: 0 }}>
                            No contracts assigned to your account. Please contact your merchant.
                        </p>
                    ) : (
                        <div className="vendor-list">
                            {contracts.map((c) => (
                                <div key={c.contractId} className="vendor-row">
                                    {contracts.length > 1 && (c.vendorName || c.vendorCode) && (
                                        <div className="vendor-row-label">
                                            {c.vendorName || c.vendorCode}
                                            {c.vendorName && c.vendorCode && (
                                                <span className="vendor-row-code">({c.vendorCode})</span>
                                            )}
                                        </div>
                                    )}
                                    <div className="vendor-row-actions">
                                        <div
                                            className="option-card"
                                            onClick={() => navigate(`/contract/${c.contractId}`)}
                                        >
                                            <div className="option-card-icon contract-icon">C</div>
                                            <div>
                                                <div className="option-card-title">Open House Contract</div>
                                                <div className="option-card-desc">View and fill out your exhibitor contract</div>
                                            </div>
                                        </div>

                                        <div
                                            className="option-card"
                                            onClick={() => navigate(`/badges/${c.vendorCode}`)}
                                        >
                                            <div className="option-card-icon badge-icon">B</div>
                                            <div>
                                                <div className="option-card-title">Badge &amp; Equipment Form</div>
                                                <div className="option-card-desc">Register attendees and request equipment</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </section>
            </main>
        </div>
    );
};

export default Welcome;
